//  app/javascript/controllers/quote_item_controller.js
import { Controller } from "@hotwired/stimulus";
import {
  fetchDiePriceTable,
  fetchClientPeelingPrice
} from "./utils/fetch_price_table";

export default class extends Controller {
  static targets = [
    "procedureName",
    "weight",
    "area",
    "quantity",
    "unit",
    "totalQuantity",
    "apiece",
    "price"
  ];

  connect() {
    console.log("quoteItemController connected");
  }

  getPreviousRow(currentRow) {
    const allRows = Array.from(currentRow.closest("tbody").children).filter(
      (el) => el.tagName === "TR"
    );
    const currentIndex = allRows.indexOf(currentRow);
    return currentIndex > 0 ? allRows[currentIndex - 1] : null;
  }

  copyFromPreviousRow() {
    const currentRow = this.element.closest("tr");
    const previousRow = this.getPreviousRow(currentRow);
    if (!previousRow) return;

    const currentRowInputs = currentRow.querySelectorAll(
      "input:not([type='checkbox'])"
    );
    const previousRowInputs = previousRow.querySelectorAll(
      "input:not([type='checkbox'])"
    );

    previousRowInputs.forEach((input, index) => {
      const key = input.name;
      let value = input.value;

      if (key.includes("[code]")) {
        value = parseInt(value, 10) + 1;
      }

      currentRowInputs[index].value = value;
    });

    const quoteItemsController =
      this.application.getControllerForElementAndIdentifier(
        document.querySelector("[data-controller='quote-items']"),
        "quote-items"
      );

    if (quoteItemsController) {
      quoteItemsController.calculateQuoteEstimatedPrice();
    }
  }

  calculateQuoteItemPrice(event) {
    // No jQuery and ajax use Stimulus, vanilla JS and fetch instead

    const quantity = parseFloat(this.quantityTarget.value) || 0;
    const apiece = parseFloat(this.apieceTarget.value) || 0;

    if (quantity === 0 || apiece === 0) {
      this.priceTarget.value = "";
      return;
    }

    this.setPriceAndEstimatedPrice(apiece, quantity);
  }

  setPriceAndEstimatedPrice(apiece, quantity) {
    const price = Math.round(quantity * apiece);
    this.priceTarget.value = price;

    // Trigger change event for Stimulus controller to recalculate estimated price
    const quoteItemsController =
      this.application.getControllerForElementAndIdentifier(
        document.querySelector("[data-controller='quote-items']"),
        "quote-items"
      );

    if (quoteItemsController) {
      quoteItemsController.calculateQuoteEstimatedPrice();
    }
  }

  async autoCalculate(branchId) {
    const t = this.weightTarget.value;
    const dm = this.areaTarget.value;
    const procedure = this.procedureNameTarget.value;

    if (procedure === "管理費") {
      const previousPrice = await this.getPreviousRowPrice();
      if (!previousPrice) return;

      const price = Math.floor(previousPrice / 10);
      this.quantityTarget.value = 1;
      this.unitTarget.value = "個";
      this.apieceTarget.value = price;
      this.priceTarget.value = price;

      this.setPriceAndEstimatedPrice(price, 1);
      return;
    }

    if (!t || !dm) return;

    let price = 0;

    if (procedure === "硬質クロム") {
      price = await fetchDiePriceTable(t, dm, branchId);
    } else if (procedure === "はくり") {
      price = await fetchClientPeelingPrice(branchId);
      this.quantityTarget.value = 1;
      this.unitTarget.value = "個";
      this.totalQuantityTarget.value = 1;
    }

    this.apieceTarget.value = parseInt(price);

    this.setPriceAndEstimatedPrice(
      parseInt(price),
      parseFloat(this.quantityTarget.value) || 0
    );
  }

  async getPreviousRowPrice() {
    const currentRow = this.element.closest("tr");

    // 直前の TR（空行などもあるため2つ上の場合もある）
    let previousRow = currentRow.previousElementSibling;

    // 無効な行（ヘッダー行/スペーサー）をスキップ
    while (previousRow && !previousRow.querySelector("[id$=_price]")) {
      previousRow = previousRow.previousElementSibling;
    }

    if (!previousRow) return null;

    const priceInput = previousRow.querySelector("[id$=_price]");
    if (!priceInput) return null;

    for (let attempt = 0; attempt <= 3; attempt++) {
      const price = parseInt(priceInput.value.replace(/,/g, ""), 10);
      const normalizedPrice = isNaN(price) ? null : price;
      if (normalizedPrice && normalizedPrice > 0) {
        return normalizedPrice;
      }
      if (attempt < 3) {
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    }
    return 0;
  }

  async deleteQuoteItem(event) {
    if (!confirm("本当に削除しますか？")) return;

    const tr = event.target.closest("tr");
    const id = tr.dataset.quoteItemId;
    tr.querySelectorAll("input:not([name=code])").forEach(
      (el) => (el.value = "")
    );

    tr.querySelectorAll("select").forEach((el) => (el.value = ""));
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/quote_items/${id}/nullify`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken
      }
    });

    if (response.ok) {
      const quoteItemsController =
        this.application.getControllerForElementAndIdentifier(
          document.querySelector("[data-controller='quote-items']"),
          "quote-items"
        );
      if (quoteItemsController) {
        quoteItemsController.calculateQuoteEstimatedPrice();
      }
      const alert = document.createElement("div");
      alert.className = "alert alert-success alert-position text-center";
      alert.innerHTML = `成功しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    } else {
      alert("更新に失敗しました");
    }
  }
}
